import { defineStore } from 'pinia';
import { ref } from 'vue';

import { useConfirmModalStore } from '#ui-shared/components/modals/confirm-modal/confirm-modal-store';
import { t } from '#ui-shared/i18n/i18n';

export const useRouteStore = defineStore('routeStore', () => {
  const externalUrl = ref('');
  const confirmModalStore = useConfirmModalStore();

  const closeExternalUrlDialog = (): void => {
    externalUrl.value = '';
  };

  const visitUrl = (): void => {
    window.open(externalUrl.value, '_blank', 'noopener noreferrer');

    closeExternalUrlDialog();
  };

  const openExternalUrlDialog = (url: string): void => {
    externalUrl.value = url;
    confirmModalStore.showConfirmModal({
      headerText: t('urlDialog.header'),
      bodyText: t('urlDialog.description'),
      confirmButtonLabel: t('urlDialog.continue'),
      cancelButtonLabel: t('urlDialog.cancel'),
      onConfirm: visitUrl,
      onCancel: closeExternalUrlDialog,
    });
  };
  return {
    externalUrl,

    openExternalUrlDialog,
    closeExternalUrlDialog,
  };
});
